import { handleApiResponse } from "../services/utils";
import axios from "../services/axiosInstance";

const solver = require("javascript-lp-solver");
const RELAX_PREFIX = "relax_";
const RELAX_MIN_SUFFIX = "min_";
const RELAX_MAX_SUFFIX = "max_";
const RELAX_PRICE_PENALTY = 999999999;

export default {
 methods: {
  //   async fftFormulation(ingredientArray, parameterArray, extractFailedConstraintsFlag = false) {
  //    let model = buildModel(ingredientArray, parameterArray);
  //    let solution = await solver.Solve(model);
  //    if (!solution.feasible && extractFailedConstraintsFlag) {
  //     const infeasible_constraints = await findInfeasibleConstraints(model);
  //     solution.failed_constraints = extractFailedConstraints(infeasible_constraints);
  //    }
  //    console.log("parameterArray", parameterArray);
  //    return solution;
  //   },
  //  },
  async fftFormulation(ingredient_array, parameter_array) {
   const result = (await handleApiResponse(() => axios.post(`/fft/v2/formulation`, { ingredient_array, parameter_array }), null)).data.data;
   console.log("result", result);
   return result;
  },
  async fftFormulationAllPrices(ingredient_array, parameter_array, target_ingredient) {
   const result = (await handleApiResponse(() => axios.post(`/fft/v2/formulation/all_prices`, { ingredient_array, parameter_array, target_ingredient }), null)).data.data;
   console.log("result", result);
   return result;
  },
 },
 data() {
  return {};
 },
};

function buildModel(ingredientArray, parameterArray) {
 //code for fft formulation algorithm
 let model = {
  options: {
   tolerance: 0.0,
  },
  optimize: "price",
  opType: "min",
  constraints: {
   WEIGHT: {
    min: 100,
    max: 100,
   },
  },
  variables: {},
  preserve_constraints: [],
 };

 parameterArray.forEach(parameter => {
  let p = processParameter(parameter);
  model.constraints = { ...model.constraints, ...p.constraints };
  model.variables = { ...model.variables, ...p.variables };
  model.preserve_constraints = [...model.preserve_constraints, ...p.preserve_constraints];
 });

 ingredientArray.forEach(ingredient => {
  let i = processIngredient(ingredient, parameterArray);
  model.constraints = { ...model.constraints, ...i.constraints };
  model.variables = { ...model.variables, ...i.variables };
  model.preserve_constraints = [...model.preserve_constraints, ...i.preserve_constraints];
 });

 return model;
}

async function findInfeasibleConstraints(model) {
 let infeasibleConstraints = {};
 let solution;
 let iter = 0;
 do {
  let iterModel = {
   ...model,
  };
  for (const [key, value] of Object.entries(iterModel.variables)) {
   iterModel.variables = { ...iterModel.variables, [key]: { ...value } };
  }
  for (const [key, value] of Object.entries(model.constraints)) {
   if (key == "WEIGHT") continue;
   if (model.preserve_constraints.includes(key)) {
    iterModel.constraints[key] = { ...value };
    continue;
   }
   let relaxed = relax_constraint(value, key);
   for (const [c_key, c_value] of Object.entries(relaxed.constraints)) {
    if (!(c_key in infeasibleConstraints)) {
     iterModel.constraints[c_key] = c_value;
    }
   }
   for (const [v_key, v_value] of Object.entries(relaxed.variables)) {
    if (!(v_key in infeasibleConstraints)) {
     iterModel.variables[v_key] = v_value;
    }
   }
  }
  solution = await solver.Solve({ ...iterModel });
  if (solution.feasible) {
   let found_infeasible_constraints = false;
   for (const [key, value] of Object.entries(solution)) {
    if (key.startsWith(RELAX_PREFIX)) {
     infeasibleConstraints[key] = value;
     found_infeasible_constraints = true;
    }
   }
   if (!found_infeasible_constraints) {
    break;
   }
  }
  iter++;
 } while (solution.feasible && iter < 1);
 return infeasibleConstraints;
}

function extractFailedConstraints(solution) {
 const failed_constraints = [];
 for (const k of Object.keys(solution)) {
  if (k.startsWith(RELAX_PREFIX)) {
   if (k.startsWith(RELAX_PREFIX + RELAX_MIN_SUFFIX)) {
    failed_constraints.push(["min", k.replace(RELAX_PREFIX + RELAX_MIN_SUFFIX, ""), solution[k]]);
   }
   if (k.startsWith(RELAX_PREFIX + RELAX_MAX_SUFFIX)) {
    failed_constraints.push(["max", k.replace(RELAX_PREFIX + RELAX_MAX_SUFFIX, ""), solution[k]]);
   }
  }
 }
 return failed_constraints;
}

function relax_constraint(constraint, name) {
 const variables = {};
 const constraints = {};
 if (constraint.min > 0) {
  const relaxed_min_constraint_name = RELAX_PREFIX + RELAX_MIN_SUFFIX + name;
  variables[relaxed_min_constraint_name] = {
   [name]: 1,
   [relaxed_min_constraint_name]: 1,
   price: RELAX_PRICE_PENALTY,
  };
  constraints[relaxed_min_constraint_name] = {
   min: 0,
   max: constraint.min,
  };
 }
 if (constraint.max < 100) {
  const relaxed_max_constraint_name = RELAX_PREFIX + RELAX_MAX_SUFFIX + name;
  variables[relaxed_max_constraint_name] = {
   [name]: -1,
   [relaxed_max_constraint_name]: 1,
   price: RELAX_PRICE_PENALTY,
  };
  constraints[relaxed_max_constraint_name] = {
   min: 0,
   max: 100 - constraint.max,
  };
 }
 return { variables, constraints };
}

function processParameter(parameter) {
 return {
  constraints: {
   [parameter.internal_name]: {
    min: parameter.min,
    max: parameter.max,
   },
  },
  variables: {},
  preserve_constraints: ["FFDRo", "FFDRm", "FIFO", "wild_fo", "wild_fm", "wild_fm_fo"],
 };
}

function processIngredient(ingredient, parameterArray) {
 //add ingredient to constraint object
 const ingridientConstraintName = ingredient.id ? ingredient.internal_name + "_" + ingredient.id : ingredient.internal_name;

 const constraints = {
  [ingridientConstraintName]: {
   min: ingredient.min,
   max: ingredient.max,
  },
 };

 const variables = {};

 //logic for adding to the variables object
 let ingredientVariableObject = {
  [ingridientConstraintName]: 1,
  WEIGHT: 1,
  price: ingredient.price,
 };
 //add all parameters to the object and divide all parameter weights by 100 except for cholestrol
 parameterArray.forEach(parameter => {
  let weight = ingredient[parameter.internal_name];
  weight = weight / 100;
  if (weight != 0) {
   ingredientVariableObject[parameter.internal_name] = weight;
  }
 });
 variables[ingridientConstraintName] = ingredientVariableObject;
 // Exclude ingredients from relaxation
 const preserve_constraints = [ingridientConstraintName];
 return { constraints, variables, preserve_constraints };
}
